import React, { useState, useEffect } from "react";
import { AjaxPost } from "../../Services/index";

export const QandAs = () => {

    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    useEffect(() => {
        setLoading(false);
        setTimeout(() => { setResult(null); }, 3000);
    }, [result])

    return (<>
        <div className="tw-text-[25px] md:tw-text-[32px] tw-text-tamarillo-700 tw-mb-[20px] tw-font-bold tk-trade-gothic-next-condensed">
            Questions and Answers
        </div>
        <div>
            {!productModel.QAs.length ?
                <div className="tw-py-[12px] tw-text-[15px] tw-pl-[12px]" style={{ borderTop: "1.5px solid #C8C8C8", borderBottom: "1.5px solid #C8C8C8" }}>
                    No questions have been asked about this item. Be the first!
                </div>
                :
                productModel.QAs.map((qa, i) =>
                    <div key={`question-answer-${i}`} className="tw-cursor-pointer tw-text-[14px] md:tw-text-[15px]" onClick={questionClick.bind(this)}
                        style={i === 0 ? { borderTop: "1.5px solid #C8C8C8", borderBottom: "1.5px solid #C8C8C8" } : { borderBottom: "1.5px solid #C8C8C8" }}>
                        <div className="tw-flex tw-justify-between tw-px-[8px] tw-w-full">
                            <div className="question tw-py-[12px]">
                                {qa.Question}
                            </div>
                            <svg className="tw-w-[18px] tw-ml-[2px] tw-mr-[12px] md:tw-mr-0 tw-shrink-0" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 612 792" style={{ enableBackground: "new 0 0 612 792", transition: "transform .2s" }} xmlSpace="preserve">
                                <g>
                                    <rect x="157.3" y="198.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -225.0565 249.6209)" width="63" height="396" />
                                    <rect x="226.2" y="365" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -156.1355 416.0993)" width="396" height="63" />
                                </g>
                            </svg>
                        </div>
                        {/*Answer*/}
                        <div style={{ display: "none", marginBottom: "18px", borderLeft: "4px solid #A71635" }} className="answer tw-ml-[18px] tw-pl-[7px]" >
                            {qa.Answer}
                        </div>
                    </div>
                )
            }
            {/*Have a question?*/}
            <div className={"tw-bg-[#F2F2F2] tw-pb-[25px] tw-mt-[26px] tw-text-[15px] tw-mb-[60px] tw-px-[20px]"} style={{ border: "1.5px solid #C0C0C0" }}>
                <div className="tw-flex tw-gap-[12px] tw-mt-[20px]">
                    <textarea maxLength="300" placeholder="Have a question about this product?" id="question-input" style={{ border: "0px solid #A71635" }}
                        className="tw-resize-none tw-w-[100%] tw-bg-white tw-px-[16px] tw-text-[15px] tw-pt-[10px] md:tw-pt-0  md:tw-content-center tw-h-[163px] md:tw-h-[50px] tw-rounded-[3px] placeholder:tw-text-mine-shaft-950 placeholder:tw-font-bold placeholder:focus:tw-text-white placeholder:tw-text-start"
                        onKeyPress={(e) => { if (e.key === 'Enter' || e.keyCode === 13) e.preventDefault() }} />
                    {window.innerWidth >= 768 &&
                        <div onClick={handleAskQuestion.bind(this)}
                            className={"tw-cursor-pointer tw-w-[152px] tw-h-[48px] tw-items-center tw-justify-center tw-uppercase tw-inline-flex tw-bg-tamarillo-700 tw-font-bold tw-text-white hover:tw-bg-tamarillo-650 tw-text-[14px] tw-rounded-[3px] " + (loading ? 'tw-pointer-events-none tw-opacity-50' : '')}>
                            Submit
                        </div>}
                </div>
                <div className="tw-mt-[12px] tw-text-[14px]">
                    Start typing your question and our associate will be already to answer your question.
                </div>
                {result === "Success" ?
                    <div className="tw-text-[14px] md:tw-text-[15px] tw-pt-[8px] tw-pb-[12px] tw-text-center tw-px-[16px] md:tw-w-fit tw-bg-[#d4edda] tw-rounded-[3px] tw-mt-[20px] ">
                        Your question has been sent!
                    </div>
                    : result === "Error" ?
                        <div className="tw-text-[14px] md:tw-text-[15px] tw-pt-[16px] tw-text-tamarillo-700">
                            There was an error sending your question. Our tech team has been notified.
                        </div>
                        : null
                }
                {window.innerWidth < 768 && <div onClick={handleAskQuestion.bind(this)}
                    className={"tw-cursor-pointer tw-h-[48px] tw-w-full tw-mt-[26px] tw-items-center tw-justify-center tw-uppercase tw-inline-flex tw-bg-tamarillo-700 tw-font-bold tw-text-white hover:tw-bg-tamarillo-650 tw-text-[15px] tw-rounded-[3px] " + (loading ? 'tw-pointer-events-none tw-opacity-50' : '')}>
                    Submit
                </div>}
            </div>
        </div></>
    );

    function questionClick(e) {
        $(e.currentTarget).find("svg").toggleClass('spin-arrow').toggleClass('svg-to-red');
        $(e.currentTarget).find(".question").toggleClass('toggle-red');
        $(e.currentTarget).find(".answer").slideToggle(200);
    }

    function handleAskQuestion(e) {
        setLoading(true);
        const question = $('#question-input');
        if (!question.val().trim()) {
            question.animate({ 'borderWidth': '3px' }, 300).animate({ 'borderWidth': '1.5px' }, 300).animate({ 'borderWidth': '3px' }, 300).animate({ 'borderWidth': '0px' }, 300);
            setTimeout(() => setLoading(false), 1200);
        }
        else {
            new AjaxPost({
                endpoint: '/products/ask-question/' + productModel.ItemGroupRecNo,
                payload: JSON.stringify(ko.toJS({
                    ItemGroupRecNo: productModel.ItemGroupRecNo,
                    Question: question.val().trim(),
                    FirstName: '',
                    PrivateUserQuestion: 'Y',
                })),
                cbFunction: function (response) {
                    if (response.message === "Success: Question sent. ") {
                        setResult("Success");
                        question.val("");
                    }
                    else if (response.message.split(':')[0] === "Error") setResult("Error");
                },
                errFunction: () => setResult("Error")
            });
        }
    }
}